import React, { Component } from 'react';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import GuestNavbar from '../navigation/guestnavbar.jsx';
import TermsDigiWallet from './TermsDigiWallet.jsx';
class termsandConditionDigiWallet extends Component {
    render() {
        return (
            <div>
            
                <div>
                    <div className="col-sm-12">
                        <GuestNavbar />
                    </div>
                    <div className="container" style={{ marginTop: "80px" }}>
                        <div className="row">
                            <TermsDigiWallet />
                        </div>
                    </div>
                </div>
        </div>
        );
    }
}

export default termsandConditionDigiWallet;


// WEBPACK FOOTER //
// ./src/components/termsandcondition/termsandconditiondigiwallet.jsx